import React, {FunctionComponent} from 'react';
import {OpenSiteSignupComponent} from '../signUp';
import {KlDialogTitle, KlResponsiveDialog} from "@klear/web-components";

const styles = require('./openSiteSignupDialog.component.scss');

interface SignupDialogProps {
    open: boolean;
    onClose: () => void;
}

export const SignupDialog: FunctionComponent<SignupDialogProps> = (props) => {
    const {open, onClose} = props;
    return (
        <KlResponsiveDialog open={open} onClose={onClose} scroll={'body'}
                            classes={{paper: styles.signupDialog, container: styles.signupDialogContainer}}>
            <KlDialogTitle
                onCancel={onClose}
                fullScreenOnly
                customBackgroundClass={styles.signupRequestDialogTitle}
                cancelClass={styles.closeButton}
                hideCancelText
                hideTitleBorder
            />
            <OpenSiteSignupComponent nextLocation={`/`}/>
        </KlResponsiveDialog>
    );
}
